<ng-container>
  <div class="welcome-container">
    <h1>{{ 'HmOnboardInvitation.Title' | translate }}</h1>
    <p>{{ 'HmOnboardInvitation.Description' | translate }}</p>

    <div class="email-input-container">
  <a-input
    type="email"
    [control]="email"
    class="form-control"
    [label]="'Auth.Email' | translate"
    [errorMessage]="getErrorMessage()"
    [isSubmitted]="formSubmitted"
    required>
  </a-input>
</div>


    <button
      class="is-btn is-btn__outfill header__public-signin"
      (click)="hmSignup()"
      [disabled]="email.invalid || inProgress">
      
      <span  class="round-loader is-trans" *ngIf="inProgress"></span>
      {{ 'HmOnboardInvitation.SignUp' | translate }}
    </button>
  </div>
</ng-container>
